export default __webpack_public_path__ + "static/media/Guru-Parampara-07.f526d20d.png";